{
  "familyId": "STU-ALFABET",
  "questions": [
    {
      "id": "STU-ALFABET-001",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een bibliothecaris heeft vier boeken gesorteerd op auteursnaam: Bram, Anna, Carla, David. Een leerling zegt: \"Dit klopt, want B komt voor A.\" Wat is er fout?",
      "options": [
        "Anna (A) moet vóór Bram (B) staan — A komt eerder in het alfabet",
        "De leerling heeft gelijk — B komt voor A",
        "Carla moet als eerste staan want C is de mooiste letter",
        "De volgorde maakt niet uit bij een bibliotheek"
      ],
      "correctAnswer": 0,
      "context": "Alfabetisering controleren — meta-redenering",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.alfabet-b-voor-a", "label": "Denkt dat B vóór A komt", "optionIndex": 1 },
          { "id": "stu.alfabet-subjectieve-volgorde", "label": "Kiest op basis van persoonlijke voorkeur", "optionIndex": 2 },
          { "id": "stu.alfabet-volgorde-optioneel", "label": "Denkt dat alfabetische volgorde optioneel is", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Alfabetisch ordenen",
            "content": "A, B, C, D... Anna begint met A en komt daarom vóór Bram (B).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_first",
      "variantIndex": 1,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De leerling denkt dat B voor A komt, maar dat klopt niet. In het alfabet is A de eerste letter, daarna pas B. Anna moet vóór Bram staan.",
        "solutionSteps": [
          "Controleer: komt B vóór A?",
          "Nee — alfabet begint met A, B, C, D...",
          "Anna (A) hoort vóór Bram (B)",
          "Juiste volgorde: Anna, Bram, Carla, David"
        ],
        "distractorExplanations": {
          "0": "Goed! A komt vóór B. Anna moet eerst staan.",
          "1": "De leerling vergist zich: A komt eerst, dan pas B.",
          "2": "Persoonlijke voorkeur speelt geen rol — het alfabet bepaalt de volgorde.",
          "3": "In een bibliotheek is alfabetische volgorde essentieel om boeken terug te vinden."
        }
      }
    },
    {
      "id": "STU-ALFABET-002",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "ordering",
      "question": "Een archivaris ordent deze woorden op alfabetische volgorde. Sleep ze in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["auto", "boom", "deur", "fiets"],
        "correctOrder": [0, 1, 2, 3]
      },
      "context": "Alfabetisch sorteren (eerste letter)",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Sorteer op de eerste letter",
            "content": "Kijk naar de eerste letter van elk woord en zet ze in alfabetische volgorde: A → B → D → F.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_sort_4words",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Eerste letters: auto (A), boom (B), deur (D), fiets (F). Alfabetische volgorde: A < B < D < F.",
        "solutionSteps": [
          "auto begint met A",
          "boom begint met B",
          "deur begint met D",
          "fiets begint met F",
          "Volgorde: auto, boom, deur, fiets"
        ]
      }
    },
    {
      "id": "STU-ALFABET-003",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een redacteur zoekt in een woordenboek het woord 'kamer'. Tussen welke woorden vindt ze dit?",
      "options": ["kaars en kast", "jas en kast", "kast en lamp", "lamp en muur"],
      "correctAnswer": 0,
      "context": "Woordenboek — woord lokaliseren",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "stu.alfabet-range-te-breed", "label": "Kiest te brede range", "optionIndex": 1 },
          { "id": "stu.alfabet-tweede-letter-overgeslagen", "label": "Kijkt niet naar tweede/derde letter", "optionIndex": 2 },
          { "id": "stu.alfabet-verkeerde-beginletter", "label": "Plaatst woord onder verkeerde beginletter", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Woordenboek gebruiken",
            "content": "Bij woorden met dezelfde beginletter: vergelijk de tweede en daarna de derde letter. KAA-rs < KAM-er < KAS-t.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "dictionary_alphabetical",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Kamer' begint met KA. Vergelijk derde letters: kaars (A), kamer (M), kast (S). A < M < S, dus 'kamer' staat tussen 'kaars' en 'kast'.",
        "solutionSteps": [
          "'Kamer' begint met KA",
          "Vergelijk derde letter: kaars (A), kamer (M), kast (S)",
          "A < M < S → kaars < kamer < kast"
        ],
        "distractorExplanations": {
          "0": "Goed! Kamer staat tussen kaars en kast.",
          "1": "'Jas en kast' is te breed — alles van J tot K. Zoek preciezer.",
          "2": "'Kast en lamp' klopt niet: KAM komt vóór KAS, dus kamer komt eerder.",
          "3": "Kamer begint met K, niet met L of M — dus niet tussen lamp en muur."
        }
      }
    },
    {
      "id": "STU-ALFABET-004",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "multiple_choice",
      "question": "Een docent maakt een woordenlijst en zet \"zebra\" als eerste woord. Een leerling zegt: \"Dat klopt niet, zebra hoort als laatste.\" Wie heeft gelijk en waarom?",
      "options": [
        "De leerling — Z is de laatste letter, dus zebra komt als laatste",
        "De docent — Z is een bijzondere letter die altijd vooraan staat",
        "Geen van beiden — zebra hoort in het midden bij de M",
        "Allebei — het maakt niet uit waar zebra staat"
      ],
      "correctAnswer": 0,
      "context": "Z als laatste letter",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.alfabet-z-speciale-positie", "label": "Denkt dat Z een speciale positie heeft", "optionIndex": 1 },
          { "id": "stu.alfabet-verkeerde-middenletter", "label": "Plaatst Z bij verkeerde middenletter", "optionIndex": 2 },
          { "id": "stu.alfabet-positie-niet-relevant", "label": "Denkt dat positie niet uitmaakt", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Z is de laatste",
            "content": "Z is de 26e en laatste letter van het alfabet. Woorden die met Z beginnen komen altijd als laatste.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_last",
      "variantIndex": 4,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De leerling heeft gelijk. Z is de laatste letter van het alfabet (A, B, C, ... X, Y, Z). Zebra hoort dus als laatste.",
        "solutionSteps": [
          "Waar staat Z in het alfabet?",
          "Z is de allerlaatste letter (26e)",
          "Woorden met Z komen als laatste",
          "De docent vergist zich"
        ],
        "distractorExplanations": {
          "0": "Goed! Z is de laatste letter. Zebra hoort als laatste.",
          "1": "Z is geen 'bijzondere' letter — het is gewoon de laatste van het alfabet.",
          "2": "Zebra begint met Z, niet M. Kijk altijd naar de eerste letter.",
          "3": "Alfabetische volgorde is een vaste afspraak — positie maakt wel uit."
        }
      }
    },
    {
      "id": "STU-ALFABET-005",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "ordering",
      "question": "Sleep deze S-woorden in alfabetische volgorde. Let op de tweede letter!",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["slang", "sneeuw", "spin", "stoel"],
        "correctOrder": [0, 1, 2, 3]
      },
      "context": "Ordenen op tweede letter (Argus Clou stijl)",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zelfde eerste letter? Kijk naar de tweede!",
            "content": "Alle woorden beginnen met S. Vergelijk de tweede letter: slang (L), sneeuw (N), spin (P), stoel (T). Alfabetisch: L < N < P < T.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_second_letter_sort",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Alle woorden beginnen met S — vergelijk dus de tweede letter: slang (L), sneeuw (N), spin (P), stoel (T). L < N < P < T.",
        "solutionSteps": [
          "Stap 1: eerste letter is bij alle vier S",
          "Stap 2: vergelijk tweede letter: L, N, P, T",
          "Stap 3: alfabetisch L < N < P < T",
          "Volgorde: slang, sneeuw, spin, stoel"
        ]
      }
    },
    {
      "id": "STU-ALFABET-006",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "ordering",
      "question": "Zet deze leerlingen op de namenlijst in alfabetische volgorde van achternaam.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["Aïsha Boomsma", "Daan de Jong", "Femke Mulder", "Karim van der Velde", "Sara Visser"],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "context": "Namenlijst alfabetiseren (schoolcontext)",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Op achternaam sorteren",
            "content": "Kijk naar de achternaam (het belangrijkste deel): Boomsma (B), Jong (J — bij 'de Jong' is 'Jong' de achternaam), Mulder (M), Velde (V), Visser (V). Bij twee V's: vergelijk de tweede letter (e vs i).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_lastnames",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij namenlijsten sorteer je op achternaam (zonder 'de', 'van', 'van der'). B (Boomsma) < J (Jong) < M (Mulder) < V (Velde) < V (Visser). Bij gelijke V: e < i, dus Velde voor Visser.",
        "solutionSteps": [
          "Achternamen: Boomsma, Jong, Mulder, Velde, Visser",
          "Eerste letters: B, J, M, V, V",
          "Bij gelijke V: Velde (e) komt vóór Visser (i)",
          "Eindvolgorde: Aïsha B., Daan de J., Femke M., Karim van der V., Sara V."
        ]
      }
    },
    {
      "id": "STU-ALFABET-007",
      "familyId": "STU-ALFABET",
      "module": "Studievaardig",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_alfabetiseren",
      "questionType": "true_false_series",
      "question": "Bekijk deze uitspraken over alfabetisch sorteren. Welke kloppen?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Bij 'aap' en 'appel' kijk je naar de tweede letter om te sorteren.", "isTrue": true },
          { "text": "'Boek' staat in een woordenboek vóór 'broer'.", "isTrue": true },
          { "text": "Hoofdletters en kleine letters worden alfabetisch hetzelfde behandeld.", "isTrue": true },
          { "text": "'Ijs' staat tussen 'huis' en 'jas' in een woordenboek.", "isTrue": true }
        ]
      },
      "context": "Alfabetiseerregels toetsen",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Alfabetiseerregels",
            "content": "Bij 'aap' (A-A-P) en 'appel' (A-P-P-E-L) is de tweede letter al verschillend (A vs P) → kijk naar 2e letter. Bij 'boek' (B-O-E) en 'broer' (B-R-O) is de 2e letter ook verschillend (O vs R) → O < R → boek eerst. IJ wordt alfabetisch behandeld als I+J in Nederlandse woordenboeken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "alphabetical_rules_judge",
      "variantIndex": 7,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Alle vier de uitspraken kloppen. Bij 'aap' (A-A-P) en 'appel' (A-P-P-E-L) is de eerste letter gelijk (A), dus je kijkt door naar de tweede letter (A vs P) — A komt vóór P, dus 'aap' eerst. 'Boek' (B-O) komt vóór 'broer' (B-R) want O < R. Hoofdletters en kleine letters tellen alfabetisch gelijk. 'IJ' wordt in Nederlandse woordenboeken behandeld als I+J en staat dus tussen 'huis' en 'jas'.",
        "solutionSteps": [
          "1. aap (A-A-P) en appel (A-P-P-E-L) → eerste letter gelijk (A), kijk naar tweede letter ✓",
          "2. boek (B-O) vs broer (B-R) → O < R → boek eerst ✓",
          "3. Hoofdletters tellen alfabetisch hetzelfde als kleine letters ✓",
          "4. IJ wordt in NL-woordenboeken behandeld als I+J → tussen H en J ✓"
        ]
      }
    }
  ]
}